var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"dal-paragraph"},_vm._l((_vm.p.split(' ')),function(word,wndex){return _c('span',{key:wndex,staticClass:"word"},_vm._l((word),function(letter,kndex){return _c('span',{key:kndex,class:_vm.spanClasses(letter),style:({
        'transition-delay': ((Math.ceil(Math.random() * 1500)) + "ms")
      })},[_vm._v("\n      "+_vm._s(letter)+"\n    ")])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6991e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dal/DalParagraph.vue
// module id = null
// module chunks = 